import { useQuery } from '@tanstack/react-query';
import { FlowKind } from 'flow-schema';

import { api, getQueryProps } from 'common';

import { FeatureFlagKey, useFlag } from '../../../../../utils/flags';
import { type FlowCreationAction } from '../../../Flows/types';
import { NewFlowDialog } from '../../../common/CreateFlow/NewFlowDialog';
import { convertTagsToFormData } from '../Fields/TagAutocomplete/utils';

interface FlowTemplatePreviewUseTemplateDialogProps {
  isOpen: boolean;
  onClose: () => void;
  flowTemplateId: string;
  flowCreationAction: FlowCreationAction;
  createFlowValues: Pick<api.FlowDefinition.CreateFlowWithDefinitionValues, 'name'> &
    (
      | { sourceFlowDefinitionId: string; data?: never }
      | { sourceFlowDefinitionId?: never; data: api.FlowDefinition.FlowData }
    );
  agentId?: string;
  organizationId?: string;
}

export function FlowTemplatePreviewUseTemplateDialog(
  props: FlowTemplatePreviewUseTemplateDialogProps
) {
  const {
    isOpen,
    onClose,
    flowTemplateId,
    flowCreationAction,
    createFlowValues,
    agentId,
    organizationId,
  } = props;
  const { showTagsOnDialog } = useFlag({
    flagKey: FeatureFlagKey.flowTagOptions,
  });

  const { data: flowTags, isPending } = useQuery({
    ...getQueryProps(api.client.FlowDefinition, 'findAllTags', {
      recordId: flowTemplateId,
      kind: FlowKind.FlowTemplate,
    }),
    enabled: showTagsOnDialog && isOpen,
  });

  if (showTagsOnDialog && isPending) {
    return null;
  }

  const formDataTags = convertTagsToFormData({ tags: flowTags });

  return (
    <NewFlowDialog
      isOpen={isOpen}
      onClose={onClose}
      createFlowValues={{
        ...createFlowValues,
        documentationMarkdown: null,
        ...(showTagsOnDialog && {
          useCaseTag: formDataTags.useCaseTag ?? undefined,
        }),
      }}
      agentId={agentId}
      organizationId={organizationId}
      flowCreationAction={flowCreationAction}
    />
  );
}
